export default "__VITE_ASSET__e0780dad__"